<template>
  <div id="demo">
    <p
      v-html="message"
      style="white-space: normal !important"
      :class="clazz"
      :style="style"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
import componentMixin from "ireal-vue/mixins/component-mixin.js";
import Bus from "../services/bus.js";

export default {
  name: "message-component",
  props: ["msg"],
  mixins: [componentMixin],
  data() {
    return {
      message: "",
    };
  },
  created() {
    this.init();
    Bus.$on("value-changed", () => {
      this.init();
    });
    Bus.$on("ireal-tick", () => {
      this.init();
    });
  },
  methods: {
    init() {
      var res = this.msg
        ? this.tx(this.msg)
        : this.tx(this.config.attributes.text || "");

      this.message = res.interpolate(this);
      res.interpolate(this).includes(undefined)
        ? (this.message = "")
        : (this.message = this.message);
    },
    time_format(elapsedTime) {
      let hour = Math.floor((elapsedTime.time / (1000 * 60 * 60)) % 24);
      let minute = Math.floor((elapsedTime.time / (1000 * 60)) % 60);
      let second = Math.floor((elapsedTime.time / 1000) % 60);
      let ms = Math.floor((elapsedTime.time % 1000) / 100);
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;

      const utc = hour + ":" + minute + ":" + second + ":" + ms;
      return utc;
    },
  },
};
</script>
